export const TILES = {
  OSM_LIGHT: 'OSM Light',
  OSM_STANDARD: 'OSM Standard',
  OSM_FRANCE: 'OSM France',
  OSM_HUMANITARIAN: 'OSM Humanitarian',
  CYCLOSM: 'CyclOSM',
  OPEN_TOPO_MAP: 'OpenTopoMap',
  WORLD_IMAGERY: 'World Imagery',
  LIVE_TRAFFIC_AZURE: 'Live Traffic Azure',
} as const;

const CARTO_API_KEY = import.meta.env.VITE_CARTO_API_KEY;

export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const CARTO_ATTRIBUTION = `${OSM_ATTRIBUTION} &copy; <a href="https://carto.com/attributions">CARTO</a>`;

export const getCartoTileUrl = (style = 'light_all') =>
  `https://basemaps.cartocdn.com/rastertiles/${style}/{z}/{x}/{y}{r}.png${
    CARTO_API_KEY ? `?key=${CARTO_API_KEY}` : ''
  }`;
